import { Provider } from '@angular/core';
import { DELIVERY_MODE_TOKEN_PROVIDER } from '@lentau/delivery-mode/shared/tokens';
import { MARKETING_PARTNER_KEY_PROVIDER } from '@lentau/mpk/application/tokens/marketing-partner-key.provider';
import { B2B_PARAMS_PROVIDER } from '@lentau/profile/application/providers/b2b-params-provider';

export const CommonBootstrapTokens: Provider[] = [
  ...MARKETING_PARTNER_KEY_PROVIDER,
  ...DELIVERY_MODE_TOKEN_PROVIDER,
  ...B2B_PARAMS_PROVIDER,
];
